import { render } from "./TableView.vue?vue&type=template&id=128e1f27&ts=true"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__